module.exports = __webpack_public_path__ + "img/some_on_1@2x.c70466cb.png";